import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CheckBadge',
    props: {
        size: { default: 74 }
    },
    setup(__props) {
        /**
         * CheckBadge — a large circular accent badge with a pop-in animation. SYNC: see
         * ../../_SYNC.md. Used by the thank-you step; the glyph is slottable.
         */
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "df-check-badge",
                style: _normalizeStyle({ width: `${__props.size}px`, height: `${__props.size}px` })
            }, [
                _renderSlot(_ctx.$slots, "default", {}, () => [
                    _cache[0] || (_cache[0] = _createTextVNode("✓", -1 /* CACHED */))
                ])
            ], 4 /* STYLE */));
        };
    }
});
